/**
 * Health-goal chip data for StackComposer.
 *
 * Two audiences, two rails:
 *
 * Logged in — CURATED shown inline (top 6, ordered by frequency), LONG_TAIL
 * folded into the "More goals" Menu. On phones the rail holds the first 4 and
 * the Menu takes the rest.
 *
 * Logged out — LOGGED_OUT_GOALS only, all 6 at every breakpoint, with no
 * "More goals" control at all. New visitors meet a short list instead of the
 * full one; anything not shown is still reachable by typing it. Order is
 * deliberate (descending expected reach) — do not sort.
 *
 * SHORT_LABELS shortens the wide labels on phones for both rails; a goal with
 * no entry displays its full name.
 *
 * Keep in sync with:
 *   - config.js PRESET_HEALTH_GOALS
 *   - backend/config/preset_goals.py
 */

export const CURATED_GOALS = [
  'Sleep Hygiene',
  'Energy',
  'Heart Health',
  'Focus',
  'Stress Relief',
  'Immunity',
];

export const LONG_TAIL_GOALS = [
  'Joint Health',
  'Hormone Balance',
  'Weight Management',
  'Muscle Health',
  'Digestion',
  'Healthy Hair & Skin',
  'Healthy Aging',
  'Memory',
  'Bone Health',
  'Prostate Health',
  'Eye Health',
  'Prenatal & Postnatal',
  'Healthy Mood',
  'Glucose Metabolism',
];

/**
 * The whole chip rail for logged-out visitors — no overflow menu behind it.
 * Ordered by expected reach, not alphabetically or by CURATED_GOALS order.
 */
export const LOGGED_OUT_GOALS = [
  'Sleep Hygiene',
  'Energy',
  'Weight Management',
  'Stress Relief',
  'Digestion',
  'Focus',
];

/** Phone-width labels. Goals absent from this map keep their full name. */
export const SHORT_LABELS = {
  'Sleep Hygiene': 'Sleep',
  'Heart Health': 'Heart',
  'Stress Relief': 'Stress',
  'Weight Management': 'Weight',
};

/** Full ordered list — curated first, then long-tail. */
export const ALL_GOALS = [...CURATED_GOALS, ...LONG_TAIL_GOALS];

/**
 * Every preset goal, grouped by area for the goal box's suggestion list
 * (STACK-565; Aravind, 2026-10-09). The groups partition ALL_GOALS exactly —
 * a test keeps them in step — and each label is the exact preset string,
 * which generation's rate-limit exemption matches on.
 */
export const GOAL_GROUPS = [
  { area: 'Sleep and mood', goals: ['Sleep Hygiene', 'Stress Relief', 'Healthy Mood'] },
  { area: 'Energy and focus', goals: ['Energy', 'Focus', 'Memory'] },
  { area: 'Heart and metabolism', goals: ['Heart Health', 'Glucose Metabolism', 'Weight Management'] },
  {
    area: 'Body',
    goals: ['Immunity', 'Digestion', 'Joint Health', 'Muscle Health', 'Bone Health', 'Eye Health', 'Healthy Hair & Skin'],
  },
  { area: 'Life stages', goals: ['Hormone Balance', 'Healthy Aging', 'Prenatal & Postnatal', 'Prostate Health'] },
];
